var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4457048%",
    y1: "12.4605654%",
    x2: "101.911592%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF28A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F38",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5E2E\\u52A9",
    transform: "translate(-64.000000, -454.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u590D\\u5236-4",
    transform: "translate(64.000000, 454.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u590D\\u5236-15",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2894737,0.868421053 C34.1199944,0.868421053 43.7105263,10.458953 43.7105263,22.2894737 C43.7105263,34.1199944 34.1199944,43.7105263 22.2894737,43.7105263 C19.851568,43.7105263 17.5087823,43.3032691 15.3254384,42.5530765 L4.02631579,42.5526316 C2.92174629,42.5526316 2.02631579,41.6572011 2.02631579,40.5526316 L2.02518406,29.2515098 C1.27542972,27.0687351 0.868421053,24.7266354 0.868421053,22.2894737 C0.868421053,10.458953 10.458953,0.868421053 22.2894737,0.868421053 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4473038,29.0218417 C14.6575606,31.8520398 17.9867752,33.6534207 21.7105134,33.6534207 L21.7105134,33.6534207 C25.4341936,33.6534207 28.7633624,31.852096 30.9736196,29.0219742",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon_help.a9db0f0e272a7f77cd03eb5d64a4b561.svg";
export { ForwardRef as ReactComponent };